import { graphql } from '../../../../graphql/generated';

export const UPDATE_PERIODIC_GROUP_MUTATION = graphql(`
  mutation UpdatePeriodicGroup($id: ID!, $input: PeriodicGroupUpdateInput!) {
    updatePeriodicGroup(id: $id, input: $input) {
      id
    }
  }
`);
